import { Recolte } from './recolte.model';
import * as moment from 'moment';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class SaisieRecolte {
    static jsonMap = {
        idRefCampagne: { key: 'idRefCampagne', optional: true },
        idRefCampagnePrecedente: { key: 'idRefCampagnePrecedente', optional: true },
        idEntreprise: { key: 'idEntreprise', optional: true },
        estDefinitive: { key: 'estDefinitive', optional: true },
        recoltes: { key: 'recoltes', converter: new (ArrayClassConverterFactory.build(Recolte))(), optional: true, default: () => [] },
        commentaire: { key: 'commentaire', optional: true, default: '' }
    };

    public idRefCampagne: number = undefined;
    public idRefCampagnePrecedente: number = undefined;
    public idEntreprise: number = undefined;
    public estDefinitive = false;
    public recoltes: Recolte[] = [];
    public commentaire: string;

    /**
     * Récolte unique pour la page de suivi et affectée dans la façade
     */
    public recolteSuivi: Recolte = new Recolte();
    /**
     * Délai calculé et affecté par la façade
     */
    public delai: number;
    public estCochee = false;

    updateTotaux() {
        new Set(this.recoltes.map(recolte => recolte.codeEspece)).forEach(codeEspece => {
            const total = this.recoltes
                .filter(r => r.isTotal && r.codeEspece === codeEspece)
                .find(o => {
                    return o != null;
                });
            (total as Recolte).qteTotale = this.recoltes
                .filter(r => !r.isTotal && r.codeEspece === codeEspece)
                .reduce((qteTotale, current) => qteTotale + current.qteTotale, 0);
            (total as Recolte).qteBio = this.recoltes
                .filter(r => !r.isTotal && r.codeEspece === codeEspece)
                .reduce((qteTotale, current) => qteTotale + current.qteBio, 0);
        });
    }

    public getSurfaceTotale(): number {
        return this.recoltes
            .map((recolte: Recolte) => recolte.surfaceTotale)
            .reduce((sufraceTotale: number, surfaceCourante: number) => sufraceTotale + surfaceCourante, 0);
    }

    public getPrevisionInitialeTotale(): number {
        return this.recoltes
            .map((recolte: Recolte) => recolte.previsionInitialeTotale)
            .reduce((previsionInitialeTotale: number, previsionInitialeCourante: number) => previsionInitialeTotale + previsionInitialeCourante, 0);
    }

    public getRandementInitialTotal(): number {
        return this.recoltes
            .map((recolte: Recolte) => recolte.getRdtInitialTotal())
            .reduce((randementInitialTotal: number, randementInitialCourant: number) => randementInitialTotal + randementInitialCourant, 0);
    }

    public getRecolteEffectiveTotale(): number {
        return this.recoltes
            .map((recolte: Recolte) => recolte.qteTotale)
            .reduce((recolteTotale: number, recolteCourante: number) => recolteTotale + recolteCourante, 0);
    }

    public getRandementEffectifTotal(): number {
        return this.recoltes
            .map((recolte: Recolte) => recolte.getRdtTotal())
            .reduce((randementTotal: number, randementCourant: number) => randementTotal + randementCourant, 0);
    }
}
